import { render } from "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=template&id=9d0a9e60&scoped=true&ts=true"
import script from "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=script&lang=ts"
export * from "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=script&lang=ts"

import "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=style&index=0&id=9d0a9e60&scoped=true&lang=css"
import "./ConfigureEmailEditPaneModalPopUp.vue?vue&type=style&index=1&id=9d0a9e60&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d0a9e60"]])

export default __exports__